import React from "react";
import { useSelector } from "react-redux";
import { Chip, Tooltip } from "@mui/material";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const CONFIG = {
  saving: { label: "Saving…", color: "info", icon: <CloudUploadIcon /> },
  offline: { label: "Offline", color: "warning", icon: <CloudOffIcon /> },
  conflict: { label: "Conflict", color: "error", icon: <WarningIcon /> },
  error: { label: "Not saved", color: "error", icon: <ErrorOutlineIcon /> },
  submitted: { label: "Submitted", color: "success", icon: <CloudDoneIcon /> },
};

const SAVED = { label: "Saved", color: "success", icon: <CloudDoneIcon /> };

export default function SyncBadge({ lastSavedAt, onRetry }) {
  const status = useSelector((state) => state.osm.status);
  const config = CONFIG[status] || SAVED;
  const canRetry = status === "error" || status === "offline";

  let help = lastSavedAt
    ? `Last saved at ${lastSavedAt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`
    : "Changes save automatically";
  if (status === "offline")
    help = "Changes will save when the connection returns. Click to retry.";
  if (status === "error") help = "The last save failed. Click to retry.";
  if (status === "conflict") help = "This script changed somewhere else.";

  return (
    <Tooltip arrow title={help}>
      <Chip
        size="small"
        icon={config.icon}
        label={config.label}
        color={config.color}
        variant="outlined"
        onClick={canRetry ? onRetry : undefined}
      />
    </Tooltip>
  );
}
